<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="title">When Giants<br/>Walked the Earth</p>
<p class="sub_title">A BIOGRAPHY OF</p>
<p class="sub_title1">LED-ZEPPELIN</p>
<p class="author">MICK WALL</p>
<p class="logo"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?9780ef52